export default Object.freeze([
    {
        name: '10',
        value: 10
    },
    {
        name: '11',
        value: 11
    },
    {
        name: '12',
        value: 12
    },
    {
        name: '13',
        value: 13
    },
    {
        name: '14',
        value: 14
    },
    {
        name: '15',
        value: 15
    },
    {
        name: '16',
        value: 16
    },
    {
        name: '17',
        value: 17
    },
    {
        name: '18',
        value: 18
    },
    {
        name: '19',
        value: 19
    },
    {
        name: '20',
        value: 20
    },
    {
        name: '21',
        value: 21
    },
    {
        name: '22',
        value: 22
    },
    {
        name: '23',
        value: 23
    },
    {
        name: '24',
        value: 24
    },
    {
        name: '25',
        value: 25
    },
    {
        name: '26',
        value: 26
    },
    {
        name: '27',
        value: 27
    },
    {
        name: '31',
        value: 31
    },
    {
        name: '32',
        value: 32
    },
    {
        name: '33',
        value: 33
    },
    {
        name: '34',
        value: 34
    },
    {
        name: '35',
        value: 35
    },
    {
        name: '36',
        value: 36
    },
    {
        name: '37',
        value: 37
    },
    {
        name: '39',
        value: 39
    },
    {
        name: '40',
        value: 40
    },
    {
        name: '41',
        value: 41
    },
    {
        name: '44',
        value: 44
    },
    {
        name: '45',
        value: 45
    },
    {
        name: '46',
        value: 46
    },
    {
        name: '49',
        value: 49
    },
    {
        name: '50',
        value: 50
    },
    {
        name: '51',
        value: 51
    },
    {
        name: '54',
        value: 54
    },
    {
        name: '55',
        value: 55
    },
    {
        name: '56',
        value: 56
    },
    {
        name: '59',
        value: 59
    },
    {
        name: '60',
        value: 60
    },
    {
        name: '61',
        value: 61
    },
    {
        name: '64',
        value: 64
    },
    {
        name: '65',
        value: 65
    },
    {
        name: '66',
        value: 66
    },
    {
        name: '72',
        value: 72
    },
    {
        name: '73',
        value: 73
    },
    {
        name: '74',
        value: 74
    },
    {
        name: '75',
        value: 75
    },
    {
        name: '79',
        value: 79
    },
    {
        name: '80',
        value: 80
    },
    {
        name: '81',
        value: 81
    },
    {
        name: '99',
        value: 99
    }
]);
